import React, { useState, useEffect } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Calendar, dateFnsLocalizer } from 'react-big-calendar';
import { format, parse, startOfWeek, getDay, startOfMonth, endOfMonth, startOfDay, endOfDay, endOfWeek } from 'date-fns';
import { Row, Col, Modal, ModalHeader, ModalBody, Button, ListGroup, ListGroupItem } from 'reactstrap';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { ScheduledAndUnScheduledSubject } from '../../constants/general.constant';
import ReactLoading from "react-loading";
import userImage from "../../files/user.png";
import moment from 'moment';
import {
  buildAppointmentStart,
  formatAppointmentDateTime,
} from '../../helpers/appointmentReminderHelper';
const locales = {
  'en-US': require('date-fns/locale/en-US'),
};

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});

const CalendarView = ({ onRangeChange, appointments, history, isLoading }) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [modal, setModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [eventModal, setEventModal] = useState(false);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [currentView, setCurrentView] = useState('month');

  const toggleModal = () => setModal(!modal);
  const toggleEventModal = () => setEventModal(!eventModal);

  useEffect(() => {
    let start, end;
    if (currentView === 'month') {
      start = startOfMonth(currentDate);
      end = endOfMonth(currentDate);
    } else if (currentView === 'week') {
      start = startOfWeek(currentDate);
      end = endOfWeek(currentDate);
    } else if (currentView === 'day') {
      start = startOfDay(currentDate);
      end = endOfDay(currentDate);
    }
    if (onRangeChange) {
      onRangeChange(format(start, 'yyyy-MM-dd'), format(end, 'yyyy-MM-dd'));
    }
  }, [currentDate, currentView, onRangeChange]);

  // Dummy data for appointments
  const generateAppointments = () => {
    const appointmentsEvent = [];

    const scheduledAppointment = appointments || [];
    scheduledAppointment.map((item) => {
      const profile = item.recepient && item.recepient.profileImage ? process.env.REACT_APP_VIDEO_CALL_REQUEST + "/" + item.recepient.profileImage : userImage;
      appointmentsEvent.push({
        id: item._id,
        patientName: item.recepient && item.recepient.fname && item.recepient.lname ? item.recepient.fname + " " + item.recepient.lname : "",
        fname: item.recepient ? item.recepient.fname : '',
        lname: item.recepient ? item.recepient.lname : '',
        patientId: item.recepient ? item.recepient._id : '',
        type: item.subject,
        date: item.reminderNoteData && item.reminderNoteData.reminderDate ? item.reminderNoteData.reminderDate : "",
        start: buildAppointmentStart(
          item.reminderNoteData?.reminderDate,
          item.reminderNoteData?.time
        ),
        end: buildAppointmentStart(
          item.reminderNoteData?.reminderDate,
          item.reminderNoteData?.time
        ),
        profileImage: profile,
        notes: item.reminderNoteData && item.reminderNoteData.notes ? item.reminderNoteData.notes : '',
        deviceName: item.device && item.device.name || '',
        createdByName: item.createdBy && item.createdBy.fname && item.createdBy.lname ? item.createdBy.fname + " " + item.createdBy.lname : "",
        time: item.reminderNoteData && item.reminderNoteData.time ? item.reminderNoteData.time : '',
        body: item.body ? item.body : ''
      })
    })
    return appointmentsEvent;
  };

  const groupEvents = (events) => {
    const grouped = {};
    events.forEach(event => {
      console.log('event', event)
      const dateStr = event.date;
      const formattedDate = moment(dateStr).format('MM/DD/YYYY');
      const time = event.time;
      const patientId = event.patientId;
      let key = `${patientId}`
      if (currentView === 'month') {
        key = `${patientId}-${formattedDate}`;
      } else {
        key = `${patientId}-${formattedDate}-${time}`;
      }
      if (!grouped[key]) {
        grouped[key] = {
          ...event,
          appointments: []
        };
      }
      grouped[key].appointments.push(event);
    });
    return Object.values(grouped);
  };

  const events = generateAppointments();
  const groupedEvents = groupEvents(events);
  const handleSelectSlot = (slotInfo) => {
    const dayAppointments = events.filter(event =>
      event.start.toDateString() === slotInfo.start.toDateString()
    );
    if (dayAppointments.length > 0) {
      setSelectedDate({ date: slotInfo.start, appointments: dayAppointments });
      setModal(true);
    }
  };

  const handleSelectEvent = (event) => {
    setSelectedEvent(event);
    setEventModal(true);
  };

  const eventStyleGetter = (event, isSelected) => {
    let backgroundColor = '#007bff'; // Vibrant blue
    let borderColor = '#007bff';
    let boxShadow = '0 4px 12px rgba(0, 123, 255, 0.4)';

    if (event.type === ScheduledAndUnScheduledSubject.unScheduled) {
      backgroundColor = '#FFC107'; // Coral red for unscheduled
      borderColor = '#FFC107';
      boxShadow = '0 4px 12px rgba(255, 107, 107, 0.4)';
    } else if (event.type === ScheduledAndUnScheduledSubject.monthlyCheckCall) {
      backgroundColor = '#2ECC71	'; // Bright green
      borderColor = '#2ECC71';
      boxShadow = '0 4px 12px rgba(81, 207, 102, 0.4)';
    } else if (event.type === ScheduledAndUnScheduledSubject.followUpPhoneCall) {
      backgroundColor = '#7a2ecc'; // Purple for follow-up phone calls
      borderColor = '#7a2ecc';
      boxShadow = '0 4px 12px rgba(122, 46, 204, 0.4)';
    }


    return {
      style: {
        backgroundColor: backgroundColor,
        border: `2px solid ${borderColor}`,
        borderRadius: '6px',
        opacity: 1,
        color: '#ffffff',
        display: 'block',
        boxShadow: boxShadow,
        fontWeight: '600',
        fontSize: '12px',
        transition: 'all 0.3s ease',
        cursor: 'pointer',
        textShadow: '0 1px 2px rgba(0,0,0,0.3)',
      },
    };
  };

  const EventComponent = ({ event }) => {
    return (
      <div className="event-component">
        {/* Event content */}
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {/* {event.profileImage ? ( */}
          {/* <img
              src={event.profileImage}
              style={{
                width: '19px',
                height: '19px',
                borderRadius: '50%',
                marginRight: '4px',
                border: '1px solid rgba(255,255,255,0.5)',
                flexShrink: 0
              }}
              onError={(e) => { e.target.src = userImage; }}
            />
          ) : null} */}
          <span style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', minWidth: 0, flex: 1 }}>{event.patientName}{event.appointments && event.appointments.length > 1 ? ` (${event.appointments.length})` : ''}</span>
          {event.time && currentView === 'month' && (
            <div style={{ fontSize: '12px', fontWeight: '400', marginTop: '2px' }}>
              ({event.time.includes(' - ') ? event.time.split(' - ')[0] : event.time})
            </div>
          )}
        </div>
      </div>
    );
  };

  const CustomToolbar = (toolbar) => {
    const { label, onNavigate, onView, views, view } = toolbar;
    return (
      <div className="rbc-toolbar">
        <div className="rbc-btn-group">
          <button onClick={() => onNavigate('PREV')}><i className="mdi mdi-chevron-left" style={{ fontSize: '21px' }}></i></button>
          <button onClick={() => onNavigate('NEXT')}><i className="mdi mdi-chevron-right" style={{ fontSize: '21px' }}></i></button>
        </div>
        <span className="rbc-toolbar-label">{label}</span>
        <div className="rbc-btn-group">
          {views.map(viewName => (
            <button
              key={viewName}
              className={view === viewName ? 'rbc-active' : ''}
              onClick={() => onView(viewName)}
            >
              {viewName.charAt(0).toUpperCase() + viewName.slice(1)}
            </button>
          ))}
        </div>
      </div>
    );
  };
  return (
    <div>
      <Row>
        <Col xs={12} md={12} lg={12} style={{overflowX : 'auto'}}>
          <div className="calendar-container">
            <Calendar
              localizer={localizer}
              events={groupedEvents || []}
              startAccessor="start"
              endAccessor="end"
              className="responsive-calendar"
              views={['month', 'week', 'day']}
              defaultView="month"
              popup
              showMore={true}
              formats={{
                eventTimeRangeFormat: ({ start, end }, culture, localizer) => localizer.format(start, 'h:mm a')
              }}
              selectable
              onSelectSlot={handleSelectSlot}
              onSelectEvent={handleSelectEvent}
              onNavigate={setCurrentDate}
              onView={setCurrentView}
              eventPropGetter={eventStyleGetter}
              components={{
                event: EventComponent,
                toolbar: CustomToolbar,
              }}
            />
            {isLoading && (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(255, 255, 255, 0.8)',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  zIndex: 10,
                }}
              >
                <div style={{ textAlign: 'center' }}>
                  <ReactLoading type="spin" color="blue" height={50} width={50} />
                </div>
              </div>
            )}
          </div>
        </Col>
      </Row>

      {/* Date Appointments Modal */}
      <Modal isOpen={modal} toggle={toggleModal} size="lg" className="appointment-modal responsive-modal modal-fullscreen-sm-down">
        <ModalHeader toggle={toggleModal}>
          <div className="d-flex align-items-center">
            <span className="font-weight-bold">Appointments for {selectedDate?.date.toDateString()}</span>
          </div>
        </ModalHeader>
        <ModalBody className="px-3 py-3 bg-light">
          <ListGroup className="appointment-list">
            {selectedDate?.appointments.map((appointment, index) => {
              let color = '#007bff'; // Vibrant blue
              if (appointment.type === ScheduledAndUnScheduledSubject.unScheduled) {
                color = '#FFC107'; // Coral red for unscheduled
              } else if (appointment.type === ScheduledAndUnScheduledSubject.monthlyCheckCall) {
                color = '#2ECC71	'; // Bright green
              } else if (appointment.type === ScheduledAndUnScheduledSubject.followUpPhoneCall) {
                color = '#7a2ecc'; // Purple for follow-up phone calls
              }

              return (
                <ListGroupItem
                  key={index}
                  tag="div"
                  className="border-0 mb-3 p-4 hover-lift position-relative"
                  style={{
                    borderRadius: '12px',
                    background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                    boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                    transition: 'all 0.3s ease',
                    position: 'relative'
                  }}
                >
                  <div className="d-flex align-items-center">
                    <img
                      src={appointment.profileImage}
                      alt={`Profile image of ${appointment.patientName}`}
                      style={{
                        width: '50px',
                        height: '50px',
                        borderRadius: '50%',
                        marginRight: '15px',
                        border: '3px solid #1E90FF	',
                        objectFit: 'cover'
                      }}
                      onError={(e) => { e.target.src = userImage; }}
                    />
                    <div>
                      <strong className="text-dark mb-1" style={{ fontSize: '1.1rem' }}>{appointment.patientName.charAt(0).toUpperCase() + appointment.patientName.slice(1)}</strong>
                      <div>
                        <small className="text-bold d-block mb-2 d-flex align-items-center mt-3" style={{ fontSize: '16px' }}>
                          <i className="mdi mdi-clock-outline mr-1"></i>
                          Appointment Time: {formatAppointmentDateTime(appointment)}
                        </small>
                      </div>
                      {appointment.createdByName && (
                        <div>
                          <small className="text-bold d-block mb-2 d-flex align-items-center mt-3" style={{ fontSize: '16px' }}>
                            <i className="mdi mdi-account mr-1"></i>
                            Created By: {appointment.createdByName}
                          </small>
                        </div>
                      )}
                      {appointment.type && (
                        <div>
                          <small className="d-flex align-items-center mt-3" style={{ fontSize: '16px', color: color }}>
                            <i className="mdi mdi-note mr-1"></i>
                            {appointment.type || "-"}
                          </small>
                        </div>
                      )}
                      {appointment.deviceName && (
                        <div>
                          <small className="text-bold d-flex align-items-center mt-3" style={{ fontSize: '16px' }}>
                            <i className="mdi mdi-devices mr-1"></i>
                            {appointment.deviceName || "-"}
                          </small>
                        </div>
                      )}
                      {appointment.body && appointment.type === ScheduledAndUnScheduledSubject.monthlyCheckCall && (
                        <div>
                          <small className="text-bold d-flex align-items-center mt-3" style={{ fontSize: '16px' }}>
                            <i className="mdi mdi-message mr-1"></i>
                            {appointment.body}
                          </small>
                        </div>
                      )}
                    </div>
                  </div>
                  <Link
                    to={`/dashboard/${appointment.fname.replace(/\s+/g, "-").replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase()}-${appointment.lname.replace(/\s+/g, "-").replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase()}/${appointment.patientId}?tab=4`}
                    className="btn more-btn"
                  >
                    <i className="mdi mdi-account-card-details"></i> More Details
                  </Link>
                </ListGroupItem>
              )
            })}
          </ListGroup>
        </ModalBody>
      </Modal>

      {/* Event Details Modal */}
      <Modal isOpen={eventModal} toggle={toggleEventModal} size="lg" className="event-modal responsive-modal modal-fullscreen-sm-down">
        <ModalHeader toggle={toggleEventModal}>
          <div className="d-flex align-items-center">
            <span className="font-weight-bold">Appointment Details for {selectedEvent?.patientName}</span>
          </div>
        </ModalHeader>
        <ModalBody className="px-3 py-3 bg-light">
          <ListGroup className="appointment-list">
            {selectedEvent?.appointments.map((appointment, index) => {
              let color = '#007bff'; // Vibrant blue
              if (appointment.type === ScheduledAndUnScheduledSubject.unScheduled) {
                color = '#FFC107'; // Coral red for unscheduled
              } else if (appointment.type === ScheduledAndUnScheduledSubject.monthlyCheckCall) {
                color = '#2ECC71	'; // Bright green
              } else if (appointment.type === ScheduledAndUnScheduledSubject.followUpPhoneCall) {
                color = '#7a2ecc'; // Purple for follow-up phone calls
              }

              return (
                <ListGroupItem
                  key={index}
                  tag="div"
                  className="border-0 mb-3 p-4 hover-lift position-relative"
                  style={{
                    borderRadius: '12px',
                    background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                    boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                    transition: 'all 0.3s ease',
                    position: 'relative'
                  }}
                >
                  <div className="d-flex align-items-center">
                    <img
                      src={appointment.profileImage}
                      alt={`Profile image of ${appointment.patientName}`}
                      style={{
                        width: '50px',
                        height: '50px',
                        borderRadius: '50%',
                        marginRight: '15px',
                        border: '3px solid #1E90FF	',
                        objectFit: 'cover'
                      }}
                      onError={(e) => { e.target.src = userImage; }}
                    />
                    <div>
                      <strong className="text-dark mb-1" style={{ fontSize: '1.1rem' }}>{appointment.patientName.charAt(0).toUpperCase() + appointment.patientName.slice(1)}</strong>
                      <div>
                        <small className="text-bold d-block mb-2 d-flex align-items-center mt-3" style={{ fontSize: '16px' }}>
                          <i className="mdi mdi-clock-outline mr-1"></i>
                          Appointment Time: {formatAppointmentDateTime(appointment)}
                        </small>
                      </div>
                      {appointment.createdByName && (
                        <div>
                          <small className="text-bold d-block mb-2 d-flex align-items-center mt-3" style={{ fontSize: '16px' }}>
                            <i className="mdi mdi-account mr-1"></i>
                            Created By: {appointment.createdByName}
                          </small>
                        </div>
                      )}
                      {appointment.type && (
                        <div>
                          <small className="d-flex align-items-center mt-3" style={{ fontSize: '16px', color: color }}>
                            <i className="mdi mdi-note mr-1"></i>
                            {appointment.type || "-"}
                          </small>
                        </div>
                      )}
                      {appointment.deviceName && (
                        <div>
                          <small className="text-bold d-flex align-items-center mt-3" style={{ fontSize: '16px' }}>
                            <i className="mdi mdi-devices mr-1"></i>
                           {appointment.deviceName || "-"}
                          </small>
                        </div>
                      )}
                      {appointment.notes && (
                        <div>
                          <small className="text-muted d-flex align-items-center mt-3" style={{ fontSize: '16px' }}>
                            <i className="mdi mdi-note mr-1"></i>
                            Notes: {appointment.notes}
                          </small>
                        </div>
                      )}
                      {appointment.body && appointment.type === ScheduledAndUnScheduledSubject.monthlyCheckCall && (
                        <div>
                          <small className="text-bold d-flex align-items-center mt-3" style={{ fontSize: '16px' }}>
                            <i className="mdi mdi-message mr-1"></i>
                            {appointment.body}
                          </small>
                        </div>
                      )}
                    </div>
                  </div>
                  <Link
                    to={`/dashboard/${appointment.fname.replace(/\s+/g, "-").replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase()}-${appointment.lname.replace(/\s+/g, "-").replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase()}/${appointment.patientId}?tab=4`}
                    className="btn more-btn"
                  >
                    <i className="mdi mdi-account-card-details"></i> More Details
                  </Link>
                </ListGroupItem>
              )
            })}
          </ListGroup>
        </ModalBody>
      </Modal>

      <style jsx>{`
        .appointment-modal .modal-content {
          border: none;
          box-shadow: 0 10px 40px rgba(0,0,0,0.1);
        }

        .patient-modal .modal-content {
          border-radius: 12px;
          border: none;
          box-shadow: 0 10px 40px rgba(0,0,0,0.1);
        }

        .hover-lift:hover {
          transform: translateY(-2px);
          transition: all 0.2s ease;
        }

        .info-row {
          display: flex;
          align-items: flex-start;
        }

        .info-label {
          min-width: 120px;
          display: flex;
          align-items: center;
        }

        .notes-box {
          background-color: #f8f9fa !important;
          border-left: 4px solid #1E90FF	;
        }

        .rbc-calendar {
          border-radius: 12px !important;
          overflow: hidden !important;
          box-shadow: 0 10px 30px rgba(0,0,0,0.1) !important;
          {/* table-layout: fixed !important; */}
        }

        .rbc-header {
          background: linear-gradient(135deg, #e3f2fd 0%, #f8f9fa 100%) !important;
          border-bottom: 2px solid #198ae3 !important;
          padding: 16px 12px !important;
          font-weight: 700 !important;
          color: #198ae3 !important;
          font-size: 16px !important;
          text-transform: uppercase !important;
          letter-spacing: 0.5px !important;
        }

        .rbc-day-bg {
          transition: all 0.3s ease !important;
        }

        .rbc-off-range-bg {
          opacity: 0.6 !important;
        }

        .rbc-event {
          border-radius: 8px !important;
          border: none !important;
          box-shadow: 0 4px 8px rgba(0,0,0,0.15) !important;
          transition: all 0.3s ease !important;
          font-weight: 600 !important;
          text-shadow: 0 1px 2px rgba(0,0,0,0.1) !important;
        }

        .rbc-event:hover {
          opacity: 1 !important;
          transform: translateY(-2px) scale(1.03) !important;
          box-shadow: 0 6px 16px rgba(0,0,0,0.2) !important;
        }

        .rbc-month-row {
          border-bottom: 1px solid #e9ecef !important;
          overflow: visible !important;
        }

        .rbc-date-cell {
          padding: 8px !important;
          font-weight: 600 !important;
          color: #495057 !important;
          cursor: pointer !important;
          text-align: center !important;
          font-size: 16px !important;
        }
        .rbc-toolbar-label{
         font-size: 21px !important;
        }
        .rbc-toolbar {
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          padding: 10px 0 !important;
          background-color: #ffffff !important;
          border-bottom: 1px solid #e9ecef !important;
        }

        .rbc-toolbar .rbc-btn-group {
          display: flex !important;
          gap: 8px !important;
        }

        .rbc-toolbar-label {
          font-size: 18px !important;
          font-weight: 600 !important;
          color: #495057 !important;
          flex: 1 !important;
          text-align: center !important;
        }

        .rbc-toolbar button {
          border-radius: 6px !important;
          padding: 8px 16px !important;
          font-weight: 500 !important;
          border: 1px solid #ddd !important;
          background-color: #f8f9fa !important;
          color: #495057 !important;
          transition: all 0.2s ease !important;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1) !important;
        }

        .rbc-toolbar button.rbc-active {
          background-color: #198ae3 !important;
          color: white !important;
          border-color: #198ae3 !important;
          box-shadow: 0 2px 6px rgba(25,138,227,0.3) !important;
        }

        .rbc-toolbar button:hover {
          background-color: #e3f2fd !important;
          color: #198ae3 !important;
          border-color: #198ae3 !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 3px 8px rgba(0,0,0,0.15) !important;
        }

        .rbc-toolbar button.rbc-active:hover {
          background-color: #1572b6 !important;
          border-color: #1572b6 !important;
        }

        .rbc-show-more {
          color: #007bff !important;
          cursor: pointer !important;
          font-size: 12px !important;
          font-weight: 600 !important;
          text-decoration: underline !important;
          background-color: rgba(255, 255, 255, 0.9) !important;
          padding: 2px 4px !important;
          border-radius: 4px !important;
          margin-top: 4px !important;
          display: block !important;
          z-index: 10 !important;
        }

        .rbc-day-slot .rbc-event, .rbc-day-slot .rbc-background-event{
          min-height: 40px
        }

        .calendar-container {
          height: 90vh;
          min-height: 600px;
        }

        .responsive-calendar {
          height: 100%;
          font-size: 16px;
          padding: 20px;
        }

        .event-component {
          display: flex;
          flex-direction: column;
          font-size: 15px;
          font-weight: 600;
          padding: 4px 6px;
        }

        .responsive-modal {
          max-width: 950px;
        }

        .more-btn {
          position: relative;
          text-align: right;
          margin-top: 10px;
        }

        @media (max-width: 767px) {
          .calendar-container {
            height: 100vh;
            overflow-x: auto;
          }
          .responsive-calendar {
            font-size: 12px !important;
            padding: 10px !important;
            min-width: 800px;
          }
          .event-component {
            font-size: 12px !important;
            padding: 2px 4px !important;
          }
          .rbc-header {
            font-size: 12px !important;
            padding: 8px 4px !important;
          }
          .rbc-date-cell {
            font-size: 12px !important;
            padding: 4px !important;
          }
          .rbc-toolbar-label {
            font-size: 14px !important;
          }
          .rbc-toolbar button {
            padding: 4px 8px !important;
            font-size: 12px !important;
          }
          .rbc-event {
            font-size: 10px !important;
          }
          .responsive-modal .modal-dialog {
            max-width: 100% !important;
            margin: 0 !important;
          }
          .responsive-modal .modal-content {
            border-radius: 0 !important;
          }
          .appointment-modal .list-group-item, .event-modal .list-group-item {
            padding: 12px !important;
          }
          .appointment-modal img, .event-modal img {
            width: 40px !important;
            height: 40px !important;
          }
          .appointment-modal strong, .event-modal strong {
            font-size: 1rem !important;
          }
          .appointment-modal small, .event-modal small {
            font-size: 14px !important;
          }
        }

        @media (min-width: 768px) and (max-width: 1023px) {
          .calendar-container {
            height: 100vh;
          }
          .responsive-calendar {
            font-size: 12px !important;
            padding: 10px !important;
            min-width: 1000px;
          }
          .responsive-calendar {
            font-size: 14px !important;
            padding: 15px !important;
          }
          .event-component {
            font-size: 14px !important;
          }
          .rbc-header {
            font-size: 14px !important;
            padding: 12px 8px !important;
          }
          .rbc-date-cell {
            font-size: 14px !important;
            padding: 6px !important;
          }
          .rbc-toolbar-label {
            font-size: 16px !important;
          }
          .rbc-toolbar button {
            padding: 6px 12px !important;
          }
          .responsive-modal {
            max-width: 90% !important;
          }
        }
      `}</style>
    </div>
  );
};

export default withRouter(CalendarView);


